import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../../axios/axiosInstance';
import { EmailVerificationStatusEnum } from '../../model/enum/EmailVerificationStatusEnum.enum';

const key = ['GET_USER_EMAIL_VERIFICATION_STATUS'];

interface UserEmailVerificationStatus {
  status: EmailVerificationStatusEnum;
}

const REFRESH_INTERVAL = 5000;
const MAX_REFETCH_COUNT = 3;

export const useGetUserEmailVerificationStatus = (email: string) => {
  return useQuery({
    queryKey: [...key],
    queryFn: async (): Promise<UserEmailVerificationStatus> => {
      const { data } = await axiosInstance.get(
        `api/member/email-status/verification-v2?recipient=${encodeURIComponent(email)}`
      );
      return data;
    },
    refetchInterval: (data) => {
      return data?.status === EmailVerificationStatusEnum.Pending ? REFRESH_INTERVAL : false;
    },
    enabled: Boolean(email),
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      const status = (error as AxiosError)?.response?.status;
      if (status === 404 || status === 403) {
        return false;
      }
      return failureCount < MAX_REFETCH_COUNT;
    }
  });
};
